<script>
  // import Chat from './Chat.svelte';
  import { Router, Link, Route } from "svelte-routing";
  
  
  import {getContext} from 'svelte';
  const db = getContext('firebase').firestore();
  const sourcesRef=db.collection("sources")

  let temp=[];
  let sources=[]
  sourcesRef.orderBy("title")
    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, " => ", doc.data());
          temp= doc.data();
          temp.id=doc.id
          sources = [...sources,temp];
      });
      //console.log("sources="+JSON.stringify(sources));
      return sources;
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
</script>

<div class="innovations">
  <h1>Sources of Tetrads</h1>
  <p>These are the sources of the quoted tetrads. Several of the books are only available used.</p>
  <div class="allSources">
      <ul>
      {#each sources as source, index}
        <li class="listitem">
        <span class="title">{source.title}</span>
        {#if source.authors != undefined}
          <span class="pubYear">({source.pubYear})</span>
          <span class="authors"> by {source.authors.toString()}</span>
          <ul>
            {#each source.tetrads as tetrad, index}
              <li class="listitem">
                <Link to="/tetrad/{tetrad.id}">{tetrad.i}</Link>
              </li>
            {/each}
          </ul>
        {/if}
        </li>
      {/each}
  </div>
</div>

<style>
  ul {list-style-type: none; margin-left: -1rem; line-height: 1.5rem; margin-bottom: 1rem;}
  .title {font-weight: bold;}
  .title:hover {text-decoration: underline;}
  .pub {font-style: italic}
  .authors {color: gray;}
  .pubYear {color: gray;}
</style>